import { useEffect, useRef, createRef, useState } from 'react'
import { createUseStyles } from 'react-jss'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useInView } from 'react-intersection-observer'
import SimpleSplitText from '@/components/SimpleSplitText'
import style from './style'

const useStyles = createUseStyles(style)

const PageTitle = ({
  title,
  parallax,
  delay,
  img1,
  img2,
}) => {
  const classes = useStyles()
  const [inViewRef, inView] = useInView({ triggerOnce: true })
  const [currentTitle, setCurrentTitle] = useState([])
  const $titles = useRef([])

  const mediaQueryKey = useSelector((state) => state.mediaQuery.key)

  // Split title if is not array
  useEffect(() => {
    setCurrentTitle(typeof title === 'string' ? title.split(' ') : title)
  }, [title])

  useEffect(() => {
    if (currentTitle.length > 0) {
      $titles.current = currentTitle.map(() => createRef())
    }
  }, [currentTitle])

  useEffect(() => {
    if (inView && $titles.current) {
      $titles.current.map((t) => {
        if (t.current) t.current.appear()
        return null
      })
    }
  }, [inView])

  return (
    <div>
      <h1
        {...{ // eslint-disable-line
          ...(parallax && {
            'data-scroll': true,
            'data-scroll-speed': -2,
          }),
        }}
      >
        {currentTitle.map((t, i) => (
          <div
            key={i.toString()}
            className={classes.titleLine}
            ref={inViewRef}
          >
            <SimpleSplitText
              ref={$titles.current[i]}
              text={t}
              appear
              disableHover
              delay={delay}
            />
            {(img1 && i === 0 && mediaQueryKey > 1) && (
              <img
                src={img1}
                alt=""
                className={`${classes.img} ${classes.img1} image`}
                data-scroll
                data-scroll-speed="1"
              />
            )}
            {(img2 && i === 2 && mediaQueryKey > 1) && (
              <img
                src={img2}
                alt=""
                className={`${classes.img} ${classes.img2} image`}
                data-scroll
                data-scroll-speed="2"
              />
            )}
          </div>
        ))}
      </h1>
    </div>
  )
}

PageTitle.defaultProps = {
  parallax: false,
  delay: 0,
}

PageTitle.propTypes = {
  parallax: PropTypes.bool,
  delay: PropTypes.number,
}

export default PageTitle
